var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},[_c('div',{staticClass:"gc-side-bar__button-primary-icon"},[_vm._t("icon")],2),_c('text-body-small',{attrs:{"line-height":"lh-lg","weight":_vm.textFontWeight}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }